module.exports = __webpack_public_path__ + "img/defaultavatar.e4c2863a.jpeg";